<template>
     <transition :name="effect">
        <div class="video-player" v-if="status" >
            <div class="video-box" @click.self="close">
                <div class="video-header clearfix">
                    <b role="button" class="video-close" @click.stop="close">×</b>
                </div>
                <div class="video-body">
                    <!-- 普通视频 -->
                    <video
                        class="video"
                        :src="url"
                        webkit-playsinline
                        playsinline
                        controls=""
                        :muted="false"
                        preload="meta"
                        autoplay="false"
                        loop="false"
                        ref="video"
                        v-if="url"
                    ></video>
                    <!-- YouTube视频 -->
                    <iframe
                        id="ytplayer"
                        type="text/html"
                        :width="isMobile ? '100%' : '1280'"
                        :height="isMobile ? setHight : '720'"
                        frameborder="0"
                        :src="youtube"
                        allowfullscreen
                        v-if="youtube"
                    />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'VideoPlayer',
    data () {
        return {
            effect: 'fade-in',
            status: false,
            url: '',
            youtube: '',
            isMobile: false,
            setHight: 0
        }
    },
    computed: {
        player () {
            return this.$refs.video
        }
    },
    methods: {
        play (url) {
            // url必填
            if(!url) {
                //console.log('video url is required.')
                return
            }

            // 写入url
            let youtube_short = url.match(/https?:\/\/youtu\.be\/(.*)/),
                youtube_long = url.match(/https?:\/\/www.youtube\.com\/watch\/?\?(.*)/),
                youtube_embed = /https?:\/\/www.youtube\.com\/embed\/.+?/.test(url)

            if(youtube_short) {
                // 短链接提取id
                this.youtube = `https://www.youtube.com/embed/${youtube_short[1]}`
            }
            else if(youtube_long) {
                // 长链接提取id
                let search = youtube_long[1]
                search.replace(/([^=]*)=([^&]*)&?/g, function(str, key, val) {
                    if(key === 'v') {
                        this.youtube = `https://www.youtube.com/embed/${decodeURIComponent(val).replace(/</g, "&lt;").replace(/>/g, "&gt;")}`
                    }
                })
            } else if(youtube_embed) {     
                // 内嵌专用链接               
                this.youtube = url
            } else {
                this.url = url
            }

            // 弹出
            this.show()
        },
        show () {
            this.status = true 
            this.changeEffect('fade-out')
        },
        close (e) {
            this.status = false
            this.url = this.youtube = ''
            this.changeEffect('fade-in')
           
        },
        changeEffect (name) {
            setTimeout(() => {
                this.effect = name
            }, 3e2)
        }
    },
    mounted() {     
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
        let setSize = () => {
            this.setHight = document.documentElement.clientHeight
        }
        window.addEventListener(resizeEvt, setSize, false)
        setSize()
    }
}
</script>

<style lang="scss">
    .video-player {
        display: table;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        font-size: 36px;
        background-color: rgba(0,0,0,0.25);
        z-index: 100;
        .video-box {
            display: table-cell;
            height: auto;
            vertical-align: middle;
            // padding-top: 20px;
            position: relative;
            max-height: 100%;
            .video-header,
            .video-body {
                width: 1300px;
                margin: auto;
            }
            .video-header {
                position: absolute;
                left: 50%;
                margin-top: -50px;
                margin-left: -650px;
            }
            .video-close {
                float: right;
                width: 48px;
                line-height: 48px;
                text-align: center;
                font-size: 100%;
                font-weight: 100;
                color: #fff;
                background-color: #000;
                transition: background-color 0.25s, color 0.25s;
                cursor: pointer;
                &:hover {
                    color: #f56c6c;
                    background-color: #fff;
                }
            }
            .video-body{
                max-height: 88%;
            }
            .video {
                width: 100%;
                max-height: 100%;
            }
        }
    }
</style>
